import preparationGraph from "./preparationGraph";
import createNodes from "./Nodes";
import setParentNodes from "./setParentNodes";
import createEdges from "./Edges";
import morphLayout from "../../../morphLayout";
export default function deserialize({ graphComponentRef, layoutAlgorithmRef, documentObjects, graphModel, nodesSource, edgesSource, groups, clearGraph, setInProgress }) {
    return new Promise((resolve, reject) => {
        try {
            const context = preparationGraph({
                graphComponentRef,
                graphModel,
                clearGraph,
                nodesSource,
                edgesSource,
                documentObjects,
                groups
            });
            createNodes(context);
            setParentNodes(context);
            createEdges(context);
            morphLayout(graphComponentRef, layoutAlgorithmRef, new Set(), new Set(context.edgeMap.values()), setInProgress, resolve, reject, false, "0");
        }
        catch (error) {
            reject(error);
        }
    });
}
